import * as React from 'react';
import * as _ from 'lodash';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { fetchPostsWP } from '../actions/posts';
import mapStateToProps from '../utils/mapStateToProps';
import mapDispatchToProps from '../utils/mapDispatchToProps';
import ListPost from './component/ListPost';
import NewLetter from './component/NewLetter';
import LikePage from './component/LikePage';

class Tags extends React.Component<any, any> {

	constructor(props: any) {
		super(props);
		this.state = {
			page: 5,
			loading: true
		}
	}

	componentDidMount() {
		this.props.fetchPostsWP({
			number: true
		});
		document.title = this.props.t('news');
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.postsWP.loading == false) {
			this.setState({
				loading: false
			})
		}
	}

	shouldComponentUpdate(nextProps) {
		if (nextProps.postsWP.loading) {
			return false;
		} else {
			return true;
		}
	}

	changePage = () => {
		this.setState((previousState) => {
			return {page: previousState.page + 5};
		});
	};

	render() {

		const { t, postsWP } = this.props;

		const { page } = this.state;

		var category_slug = '';

		if (this.props.match.params.tag_slug) {
			category_slug = this.props.match.params.tag_slug;
		}

		var data_categories = _.filter(postsWP.data, function (post) {
			return _.some(post.terms, { 'slug': category_slug, 'taxonomy': 'post_tag' });
		});

		var pagedItems = _.drop(data_categories, 0).slice(0, page);

		var data_post = pagedItems.map((item, key) => {
			return (
				<ListPost key={key} category_slug={category_slug} item={item}/>
			);
		});

		return (
			<div className="news listNews">
				<div className="container">
					<div className="row">
						<div className="col-md-12 col-lg-8 columnLeft">
							{data_post}
						</div>
						<div className="col-sm-4 columnRight ">
							<div className="sidebarNews">
								<LikePage/>
								<NewLetter/>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-sm-12">
							{page >= data_categories.length ? '' :
								<div className="load-more-wrapper">
									<div onClick={this.changePage} className="btn btn-block  click-load">
										<span>{t('view_more')}</span>
									</div>
								</div>}
						</div>
					</div>
				</div>
				{this.state.loading ? <div className="loadingPage active"> <img src={require('../img/Spin-1s-58px.gif')}/></div> : '' }
			</div>
		);
	}
}

export default connect(mapStateToProps([
	'postsWP'
]), mapDispatchToProps({
	fetchPostsWP
}))(translate('translations')(Tags));



// WEBPACK FOOTER //
// ./src/containers/Tags.tsx